import { CaretRight, Pause } from '@phosphor-icons/react'
import { Icon, LinkButton } from '@shopflo/ui'
import React from 'react'
import { useOrganisationContext } from 'src/lib/contexts/OrganisationContext'
import { ChurnSwitchEventsName, useChurnSwitchEvents } from 'src/lib/hooks/useChurnSwitchEvents'
import { useLocale } from 'src/lib/hooks/useLocal'
import { updateOrganizationStatus } from 'src/lib/utils/billingHelpers'
import { errorToast } from 'src/lib/utils/toasters'

const ReactivationBanner = () => {
  const {
    getters: {
      organisationData: { status, id }
    },
    actions: { refetchOrganisation }
  } = useOrganisationContext()
  const { t } = useLocale()
  const { sendChurnSwitchEvents } = useChurnSwitchEvents()

  const handleReactivate = async () => {
    try {
      const response = await updateOrganizationStatus('LIVE', id)
      sendChurnSwitchEvents(
        {
          switch_state: 'on'
        },
        ChurnSwitchEventsName.CHURN_SWITCH
      )
      refetchOrganisation()
    } catch (err: any) {
      errorToast(err?.message ?? t('something_went_wrong'))
      console.error(err)
    }
  }

  if (status !== 'DISABLED') {
    return <></>
  }

  return (
    <div className='px-1.5 pb-1.5 -mt-0.5'>
      <div className='bg-zinc-700 w-full flex items-center justify-between p-[10px] text-sm rounded-b-xl border-1 border-gray-200'>
        <div className='flex items-center w-full justify-center text-zinc-100 gap-2'>
          <div className='flex items-center'>
            <Icon IconComponent={Pause} size='sm' />
            <h3 className='text-text-xs-semibold'>{t('churn_switch.reactivation_banner_title')}</h3>
          </div>
          <p className='text-white/60 text-text-xs-medium'>{t('churn_switch.reactivation_banner_subtext')}</p>
          <LinkButton
            className='underline'
            variant='bright'
            size='xs'
            rightIcon={<CaretRight />}
            onClick={handleReactivate}
          >
            {t('churn_switch.reactivation_banner_button')}
          </LinkButton>
        </div>
      </div>
    </div>
  )
}

export default ReactivationBanner
